import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { FullCalendarModule } from 'primeng/fullcalendar';
import { GalleriaModule } from 'primeng/galleria';
import { InplaceModule } from 'primeng/inplace';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { KnobModule } from 'primeng/knob';
import { LightboxModule } from 'primeng/lightbox';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { StepsModule } from 'primeng/steps';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { BlockUIModule } from 'primeng/blockui';
import { EditorModule } from 'primeng/editor';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AppCodeModule } from './app.code.component';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { AppConfigComponent } from './app.config.component';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuitemComponent } from './app.menuitem.component';
import { AppInlineMenuComponent } from './app.inlinemenu.component';
import { AppRightMenuComponent } from './app.rightmenu.component';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { AppTopBarComponent } from './app.topbar.component';
import { AppFooterComponent } from './app.footer.component';
import { MenuService } from './app.menu.service';
import { AppBreadcrumbService } from './app.breadcrumb.service';
import { TovpilCatalogsComponent } from './tovpil-catalogs/tovpil-catalogs.component';
import { TovpilCatalogsCoordZonalComponent } from './tovpil-catalogs-coord-zonal/tovpil-catalogs-coord-zonal.component';
import { TovpilCatalogsCoordNatioComponent } from './tovpil-catalogs-coord-natio/tovpil-catalogs-coord-natio.component';
import { TovpilCatalogsCoordLocalComponent } from './tovpil-catalogs-coord-local/tovpil-catalogs-coord-local.component';
import { TovpilCatalogsCountriesComponent } from './tovpil-catalogs-countries/tovpil-catalogs-countries.component';
import { TovpilCatalogsZonalDetailComponent } from './tovpil-catalogs-zonal-detail/tovpil-catalogs-zonal-detail.component';
import { TovpilCatalogsCoordTeamComponent } from './tovpil-catalogs-coord-team/tovpil-catalogs-coord-team.component';
import { LoginComponent } from './login/login.component';
import { TovpilElectovComponent } from './tovpil-electov-choose/tovpil-electov.component';
import { TovpilElectovChooseConfirmComponent } from './tovpil-electov-choose-confirm/tovpil-electov-choose-confirm.component';
import { OrdersToShipComponent } from './materials/orders-to-ship/orders-to-ship.component';
import { OrdersWarehouseComponent } from './materials/orders-warehouse/orders-warehouse.component';
import { OrdersShippingDetailComponent } from './materials/orders-shipping-detail/orders-shipping-detail.component';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { SuppliesRequestedComponent } from './materials/supplies-requested/supplies-requested.component';
import { TovpilEmailsReviewComponent } from './tovpil-emails-review/tovpil-emails-review.component';
import { DatePipe } from '@angular/common';
import { TovpilIncidentsReviewComponent } from './tovpil-incidents-review/tovpil-incidents-review.component';
import { TovpilIncidentsReviewDtlComponent } from './tovpil-incidents-review-dtl/tovpil-incidents-review-dtl.component';
import { TovpilIncidentsCheckHoursComponent } from './tovpil-incidents-check-hours/tovpil-incidents-check-hours.component';
import { TovpilOptionsAssistsComponent } from './tovpil-options-assists/tovpil-options-assists.component';
import { StoredPeriodHdrComponent } from './catalogs/stored-period-hdr/stored-period-hdr.component';
import { StoredPeriodDtlComponent } from './catalogs/stored-period-dtl/stored-period-dtl.component';
import { TovpilDatePipe } from './utils/TovpilDatePipe';
import { OptionRulesHdrComponent } from './commons/option-rules-hdr/option-rules-hdr.component';
import { UsersSupportComponent } from './commons/users-support/users-support.component';
import { PartipantForm0Component } from './secretary/partipant-form0/partipant-form0.component';
import { PartipantDtlComponent } from './secretary/partipant-dtl/partipant-dtl.component';
import { WorkshopSessionComponent } from './secretary/workshop-session/workshop-session.component';
import { WorkshopSessionAssistComponent } from './secretary/workshop-session-assist/workshop-session-assist.component';
import { FutureGuidesSchoolsComponent } from './secretary/future-guides-schools/future-guides-schools.component';
import { StsGuideComponent } from './reports/sts-guide/sts-guide.component';
import { ShopComponent } from './santovstorew/shop/shop.component';
import { ExternGuidesComponent } from './commons/extern-guides/extern-guides.component';
import { GuideFileSupportComponent } from './secretary/guide-file-support/guide-file-support.component';
import { TracingWorkshopsComponent } from './reports/tracing-workshops/tracing-workshops.component';
import { TracingWorkshopsDetailComponent } from './reports/tracing-workshops-detail/tracing-workshops-detail.component';
import { ItemsTrackDwnComponent } from './santovstorew/shop/items-track-dwn.component';
import { ItemsAlbumListComponent } from './santovstorew/shop/items-album-list.component';
import { SentGuidesComponent } from './reports/sts-guide/sent-guides.component';
import { FutureGuidesSumComponent } from './reports/future-guides/future-guides-sum.component';
import { GuidelinesAssistComponent } from './commons/guidelines-assist/guidelines-assist.component';
import { GuidelinesAssistDt1Component } from './commons/guidelines-assist/guidelines-assist-dt1.component';
import { GuidelinesAssistDt2Component } from './commons/guidelines-assist/guidelines-assist-dt2.component';
import { CommonNotavailableyetComponent } from './commons/common-notavailableyet/common-notavailableyet.component';
import { DashboarstsguidesComponent } from './reports/dashboarstsguides/dashboarstsguides.component';
import { CookieService } from 'ngx-cookie-service';
import { SecurityOptionTransactionComponent } from './commons/security-option-transaction/security-option-transaction.component';
import { GuidesReportsComponent } from './reports/guides-reports/guides-reports.component';
import { TovpilOrganitationComponent } from './catalogs/tovpil-organitation/tovpil-organitation.component';
import { PurchasingSumComponent } from './reports/materials/purchasing-sum/purchasing-sum.component';
import { EmailTemplateComponent } from './commons/email-template/email-template.component';
import { WorkshopComponent } from './guide/workshop/workshop.component';
import { WorkshopDetailComponent } from './guide/workshop-detail/workshop-detail.component';
import { WorkshopParticipantComponent } from './guide/workshop-participant/workshop-participant.component';
import { InvdetAdjustmentComponent } from './materials/invdet-adjustment/invdet-adjustment.component';
import { WorkshopParticipantDetailComponent } from './guide/workshop-participant-detail/workshop-participant-detail.component';
import { ChangePasswordComponent } from './catalogs/change-password/change-password.component';
import { UserComponent } from './catalogs/user/user.component';
import { WorkshopAssistanceComponent } from './guide/workshop-assistance/workshop-assistance.component';
import { RecoverPasswordComponent } from './guide/recover-password/recover-password.component';
import { CreaterUserComponent } from './guide/creater-user/creater-user.component';
import { TabDirective } from './utils/TabDirective';
import { ChurchDetailComponent } from './guide/church/church-detail/church-detail.component';
import { ChurchListComponent } from './guide/church/church-list/church-list.component';
import { PurchItmDwnListComponent } from './materials/purchasing/purch-itm-dwn-list/purch-itm-dwn-list.component';
import { PurchItmDwnDetailComponent } from './materials/purchasing/purch-itm-dwn-detail/purch-itm-dwn-detail.component';
import { SchoolfpgComponent } from './catalogs/eppgs/schoolfpg/schoolfpg.component';
import { SchoolfpgDetailComponent } from './catalogs/eppgs/schoolfpg-detail/schoolfpg-detail.component';
import { ShoolfpgParticipantComponent } from './catalogs/eppgs/shoolfpg-participant/shoolfpg-participant.component';
import { ShoolfpgParticipantDetailComponent } from './catalogs/eppgs/shoolfpg-participant-detail/shoolfpg-participant-detail.component';
import { SchoolAssistanceComponent } from './secretary/workshops/school-assistance/school-assistance.component';
import { EpgListComponent } from './secretary/epg-list/epg-list.component';
import { WorkshopMngComponent } from './secretary/workshop-mng/workshop-mng.component';
import { WorkshopLgcComponent } from './secretary/workshop-lgc/workshop-lgc.component';
import { VersionHistoryComponent } from './catalogs/version-history/version-history.component';
import { MongoSyncComponent } from './commons/mongo-sync/mongo-sync.component';
import { PurchOrdSupLstComponent } from './materials/purch-ord-sup-lst/purch-ord-sup-lst.component';
import { PurchOrdSupDtlComponent } from './materials/purch-ord-sup-dtl/purch-ord-sup-dtl.component';
import { UserslstComponent } from './catalogs/userslst/userslst.component';
import { CoordinationCatalogComponent } from './catalogs/coordination-catalog/coordination-catalog.component';
import { SupplierlstComponent } from './catalogs/supplierlst/supplierlst.component';
import { QuerysViewComponent } from './commons/querys-view/querys-view.component';
import { CoordinationCatalogDtlComponent } from './catalogs/coordination-catalog-dtl/coordination-catalog-dtl.component';
import { LocalNationalOrderComponent } from './materials/local-national-order/local-national-order.component';
import { LocalNationalOrderDtlComponent } from './materials/local-national-order-dtl/local-national-order-dtl.component';
import { RecoverLinkComponent } from './electov/recover-link/recover-link.component';
import { RecordInvHdrComponent } from './materials/record-inv-hdr/record-inv-hdr.component';
import { RecordInvDtlComponent } from './materials/record-inv-dtl/record-inv-dtl.component';
import { FIIConceptsComponent } from './treasurer/fiiconcepts/fiiconcepts.component';
import { LocalNationalOrderMapComponent } from './materials/local-national-order-map/local-national-order-map.component';
import { GMapModule } from 'primeng/gmap';
import { LocalNationalOrderLeafletComponent } from './materials/local-national-order-leaflet/local-national-order-leaflet.component';
import { MarkerService } from './utils/marker.service';
import { PopUpService } from './utils/popup.service';
import { ShapeService } from './utils/shape.service';
import { FiiconceptsDtlComponent } from './treasurer/fiiconcepts-dtl/fiiconcepts-dtl.component';
import { PriceListIntComponent } from './treasurer/price-list-int/price-list-int.component';
import { PriceListZonComponent } from './treasurer/price-list-zon/price-list-zon.component';
import { PriceCountryComponent } from './treasurer/price-country/price-country.component';
import { PriceListComponent } from './treasurer/price-list/price-list.component';
import { LocMatCtlLstComponent } from './treasurer/loc-mat-ctl/loc-mat-ctl.component';
import { LocMatCtlMComponent } from './treasurer/loc-mat-ctl-m/loc-mat-ctl-m.component';
import { LocMatCtlDtlComponent } from './treasurer/loc-mat-ctl-dtl/loc-mat-ctl-dtl.component';
import { LcSelectorComponent } from './treasurer/lc-selector/lc-selector.component';
import { FiiListComponent } from './treasurer/fii-list/fii-list.component';
import { FiiReceivePayableComponent } from './treasurer/fii-receive-payable/fii-receive-payable.component';
import { FiiReceivePayableSummaryComponent } from './treasurer/fii-receive-payable-summary/fii-receive-payable-summary.component';
import { FiiJournlEsLstComponent } from './treasurer/fii-journl-es-lst/fii-journl-es-lst.component';
import { FiiEconomicRealityComponent } from './treasurer/fii-economic-reality/fii-economic-reality.component';
import { FiiJournlComponent } from './treasurer/fii-journl/fii-journl.component';
import { JrnhGuideReferComponent } from './treasurer/jrnh-guide-refer/jrnh-guide-refer.component';
import { FiSummaryComponent } from './secretary/fi-summary/fi-summary.component';
import { JrnhGuideReferExpComponent } from './treasurer/jrnh-guide-refer-exp/jrnh-guide-refer-exp.component';
import { FiiJournlConceptDtlComponent } from './treasurer/fii-journl-concept-dtl/fii-journl-concept-dtl.component';
import { FvSummaryMatterComponent } from './treasurer/fv-summary-matter/fv-summary-matter.component';
import { ItemsPersAlbumListComponent } from './santovstorew/shop/items-pers-album-list/items-pers-album-list.component';
import { ItemsPerstrackDwnComponent } from './santovstorew/shop/items-perstrack-dwn/items-perstrack-dwn.component';
import { FvSummaryMatterDtlComponent } from './treasurer/fv-summary-matter-dtl/fv-summary-matter-dtl.component';
import { FvSummaryMatterRecpayComponent } from './treasurer/fv-summary-matter-recpay/fv-summary-matter-recpay.component';
import { StoreCurrencyAdmComponent } from './commons/store-currency-adm/store-currency-adm.component';
import { MatNatReqLstComponent } from './materials/mat-nat-req/mat-nat-req-lst/mat-nat-req-lst.component';
import { MatNatReqDtlComponent } from './materials/mat-nat-req/mat-nat-req-dtl/mat-nat-req-dtl.component';
import { ConfirmAudioReprodComponent } from './treasurer/confirm-audio-reprod/confirm-audio-reprod.component';
import { GuidesItemSummaryComponent } from './treasurer/guides-item-summary/guides-item-summary.component';
import { TovpilCatalogsNatioDetailComponent } from './tovpil-catalogs-natio-detail/tovpil-catalogs-natio-detail.component';
import { TovpilCatalogsLocalDetailComponent } from './tovpil-catalogs-local-detail/tovpil-catalogs-local-detail.component';
import { TovpilMaterialsVideoComponent } from './materials/tovpil-materials-video/tovpil-materials-video.component';
import { TovpilMaterialsVideoDetailVimeoComponent } from './materials/tovpil-materials-video-detail-vimeo/tovpil-materials-video-detail-vimeo.component';
import { TracingGrantAudiosDetailComponent } from './reports/tracing-grant-audios/tracing-grant-audios-detail/tracing-grant-audios-detail.component';
import { TracingGrantAudiosComponent } from './reports/tracing-grant-audios/tracing-grant-audios/tracing-grant-audios.component';
import { SchoolfpgParticipantTransferComponent } from './catalogs/eppgs/schoolfpg-participant-transfer/schoolfpg-participant-transfer.component';
import { NotranslateDirective } from './directives/notranslate.directive';
import { CrudPropertiesDocument } from './commons/crud-properties-document/crud-properties-document.component';
import { TovpilMaterialsVideoUploadComponent } from './materials/tovpil-materials-video-upload/tovpil-materials-video-upload.component';
import { CrudExternGuidesDocumentComponent } from './commons/crud-extern-guides-document/crud-extern-guides-document.component';
import { TovpilMaterialsVideoUploadDetailComponent } from './materials/tovpil-materials-video-upload-detail/tovpil-materials-video-upload-detail.component';
import { TovpilMaterialsVideoDetailYoutubeComponent } from './materials/tovpil-materials-video-detail-youtube/tovpil-materials-video-detail-youtube.component';
import { AudiosGrantsExternGuidesComponent } from './treasurer/audios-grants-extern-guides/audios-grants-extern-guides.component';
import { FviiEconrealComponent } from './treasurer/fvii-econreal/fvii-econreal.component';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/');
}

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AccordionModule,
    AutoCompleteModule,
    AvatarModule,
    AvatarGroupModule,
    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CalendarModule,
    CardModule,
    CarouselModule,
    CascadeSelectModule,
    ChartModule,
    CheckboxModule,
    ChipModule,
    ChipsModule,
    CodeHighlighterModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    ColorPickerModule,
    ContextMenuModule,
    DataViewModule,
    DialogModule,
    DividerModule,
    DropdownModule,
    FieldsetModule,
    FileUploadModule,
    FullCalendarModule,
    GalleriaModule,
    InplaceModule,
    InputNumberModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    KnobModule,
    LightboxModule,
    ListboxModule,
    MegaMenuModule,
    MenuModule,
    MenubarModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    OrderListModule,
    OrganizationChartModule,
    OverlayPanelModule,
    PaginatorModule,
    PanelModule,
    PanelMenuModule,
    PasswordModule,
    PickListModule,
    ProgressBarModule,
    RadioButtonModule,
    RatingModule,
    RippleModule,
    ScrollPanelModule,
    ScrollTopModule,
    SelectButtonModule,
    SidebarModule,
    SkeletonModule,
    SlideMenuModule,
    SliderModule,
    SplitButtonModule,
    SplitterModule,
    StepsModule,
    TableModule,
    TabMenuModule,
    TabViewModule,
    TagModule,
    TerminalModule,
    TimelineModule,
    TieredMenuModule,
    ToastModule,
    ToggleButtonModule,
    ToolbarModule,
    TooltipModule,
    TreeModule,
    TreeTableModule,
    VirtualScrollerModule,
    BlockUIModule,
    EditorModule,
    AppCodeModule,
    GMapModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAnalyticsModule
  ],
  declarations: [
    AppComponent,
    AppMainComponent,
    AppConfigComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    AppInlineMenuComponent,
    AppRightMenuComponent,
    AppBreadcrumbComponent,
    AppTopBarComponent,
    AppFooterComponent,
    TovpilCatalogsComponent,
    TovpilCatalogsCoordZonalComponent,
    TovpilCatalogsCoordNatioComponent,
    TovpilCatalogsCoordLocalComponent,
    TovpilCatalogsCountriesComponent,
    TovpilCatalogsZonalDetailComponent,
    TovpilCatalogsCoordTeamComponent,
    LoginComponent,
    TovpilElectovComponent,
    TovpilElectovChooseConfirmComponent,
    OrdersToShipComponent,
    OrdersWarehouseComponent,
    OrdersShippingDetailComponent,
    SuppliesRequestedComponent,
    TovpilEmailsReviewComponent,
    TovpilIncidentsReviewComponent,
    TovpilIncidentsReviewDtlComponent,
    TovpilIncidentsCheckHoursComponent,
    TovpilOptionsAssistsComponent,
    StoredPeriodHdrComponent,
    StoredPeriodDtlComponent,
    TovpilDatePipe,
    OptionRulesHdrComponent,
    UsersSupportComponent,
    PartipantForm0Component,
    PartipantDtlComponent,
    WorkshopSessionComponent,
    WorkshopSessionAssistComponent,
    FutureGuidesSchoolsComponent,
    StsGuideComponent,
    ShopComponent,
    ExternGuidesComponent,
    GuideFileSupportComponent,
    TracingWorkshopsComponent,
    TracingWorkshopsDetailComponent,
    ItemsTrackDwnComponent,
    ItemsAlbumListComponent,
    SentGuidesComponent,
    FutureGuidesSumComponent,
    GuidelinesAssistComponent,
    GuidelinesAssistDt1Component,
    GuidelinesAssistDt2Component,
    CommonNotavailableyetComponent,
    DashboarstsguidesComponent,
    SecurityOptionTransactionComponent,
    GuidesReportsComponent,
    TovpilOrganitationComponent,
    PurchasingSumComponent,
    EmailTemplateComponent,
    WorkshopComponent,
    WorkshopDetailComponent,
    WorkshopParticipantComponent,
    InvdetAdjustmentComponent,
    WorkshopParticipantDetailComponent,
    ChangePasswordComponent,
    UserComponent,
    WorkshopAssistanceComponent,
    RecoverPasswordComponent,
    CreaterUserComponent,
    TabDirective,
    ChurchDetailComponent,
    ChurchListComponent,
    PurchItmDwnListComponent,
    PurchItmDwnDetailComponent,
    SchoolfpgComponent,
    SchoolfpgDetailComponent,
    ShoolfpgParticipantComponent,
    ShoolfpgParticipantDetailComponent,
    SchoolAssistanceComponent,
    EpgListComponent,
    WorkshopMngComponent,
    WorkshopLgcComponent,
    VersionHistoryComponent,
    MongoSyncComponent,
    PurchOrdSupLstComponent,
    PurchOrdSupDtlComponent,
    UserslstComponent,
    CoordinationCatalogComponent,
    SupplierlstComponent,
    QuerysViewComponent,
    CoordinationCatalogDtlComponent,
    LocalNationalOrderComponent,
    LocalNationalOrderDtlComponent,
    RecoverLinkComponent,
    RecordInvHdrComponent,
    RecordInvDtlComponent,
    FIIConceptsComponent,
    LocalNationalOrderMapComponent,
    LocalNationalOrderLeafletComponent,
    FiiconceptsDtlComponent,
    PriceListIntComponent,
    PriceListZonComponent,
    PriceCountryComponent,
    PriceListComponent,
    LocMatCtlLstComponent,
    LocMatCtlMComponent,
    LocMatCtlDtlComponent,
    LcSelectorComponent,
    FiiListComponent,
    FiiReceivePayableComponent,
    FiiReceivePayableSummaryComponent,
    FiiJournlEsLstComponent,
    FiiEconomicRealityComponent,
    FiiJournlComponent,
    JrnhGuideReferComponent,
    FiSummaryComponent,
    JrnhGuideReferExpComponent,
    FiiJournlConceptDtlComponent,
    FvSummaryMatterComponent,
    ItemsPersAlbumListComponent,
    ItemsPerstrackDwnComponent,
    FvSummaryMatterDtlComponent,
    FvSummaryMatterRecpayComponent,
    StoreCurrencyAdmComponent,
    MatNatReqLstComponent,
    MatNatReqDtlComponent,
    ConfirmAudioReprodComponent,
    GuidesItemSummaryComponent,
    TovpilCatalogsNatioDetailComponent,
    TovpilCatalogsLocalDetailComponent,
    TovpilMaterialsVideoComponent,
    TovpilMaterialsVideoDetailVimeoComponent,
    TracingGrantAudiosComponent,
    TracingGrantAudiosDetailComponent,
    SchoolfpgParticipantTransferComponent,
    NotranslateDirective,
    CrudPropertiesDocument,
    TovpilMaterialsVideoUploadComponent,
    CrudExternGuidesDocumentComponent,
    TovpilMaterialsVideoUploadDetailComponent,
    TovpilMaterialsVideoDetailYoutubeComponent,
    AudiosGrantsExternGuidesComponent,
    FviiEconrealComponent
  ],
  providers: [
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    { provide: LocationStrategy, useClass: HashLocationStrategy },
    MenuService, AppBreadcrumbService, CookieService, MarkerService, PopUpService, ShapeService,
    ScreenTrackingService,
    UserTrackingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
